
import { useFeatureFlagsContext } from "web/context/featureFlags";

const useFeatureFlag = (feature: string) => {
    const featureFlags = useFeatureFlagsContext();
    return featureFlags.find((flag) => flag.name === feature)?.active || false;
};

export default useFeatureFlag;